import { isNotNull } from "@portal/app/_common/lib/helpers";

export const sumProgramCosts = (costs: { cost: number }[]): number =>
  costs.reduce((prev, curr) => prev + curr.cost, 0);

export const calculateLowestStartAmount = (dreamSearchResult: {
  program: {
    costs: { id: string; cost: number }[];
    eligiblePaymentOptions: {
      estimatedFirstPayment: number | null;
    }[];
  };
  provider: { isPartnered: boolean };
}) => {
  const totalCost = sumProgramCosts(dreamSearchResult.program.costs);

  if (totalCost === 0 && !dreamSearchResult.provider.isPartnered) {
    return null;
  }

  const lowestStartingPrice =
    dreamSearchResult.program.eligiblePaymentOptions
      .map((po) => po.estimatedFirstPayment)
      .filter(isNotNull)
      .filter((price) => price !== 0)
      .sort((a, b) => a - b)[0] || 0;

  const isLowestPaymentOptionCheaperThanTotal =
    lowestStartingPrice !== 0 && lowestStartingPrice < totalCost;

  return isLowestPaymentOptionCheaperThanTotal ? lowestStartingPrice : totalCost;
};
